import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { DealForm } from "./Forms/DealForm";
import { StageForm } from "./Forms/StageForm";
import { CompanyForm } from "./Forms/CompanyForm";
import { ContactForm } from "./Forms/ContactForm";

// Deal Modal
export const DealModal = ({
  open,
  onClose,
  onSubmit,
  companies,
  contacts,
  stages,
  onAddCompany,
  onAddContact,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            Create New Lead
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DealForm
          onSubmit={onSubmit}
          companies={companies}
          contacts={contacts}
          stages={stages}
          onAddCompany={onAddCompany}
          onAddContact={onAddContact}
          showActions={true}
        />
      </DialogContent>
    </Dialog>
  );
};

// Stage Modal
export const StageModal = ({
  open,
  onClose,
  onSubmit,
  editMode = false,
  initialData = null,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"}>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body1" fontWeight={700}>
            {editMode ? "Edit Stage" : "Create New Stage"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <StageForm
          initialValues={initialData}
          onSubmit={onSubmit}
          editMode={editMode}
          showActions={true}
        />
      </DialogContent>
    </Dialog>
  );
};

// Company Modal
export const CompanyModal = ({ open, onClose, onSubmit }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            Add New Company
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <CompanyForm onSubmit={onSubmit} showActions={true} />
      </DialogContent>
    </Dialog>
  );
};

// Contact Modal
export const ContactModal = ({ open, onClose, onSubmit, companies }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            Create New Contact
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <ContactForm
          onSubmit={onSubmit}
          companies={companies}
          showActions={true}
        />
      </DialogContent>
    </Dialog>
  );
};

// Delete Confirm Dialog
export const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Deletion",
  itemName,
  message,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {message || (
            <>
              Are you sure you want to delete{" "}
              {itemName && <strong>{itemName}</strong>}? <br />
              This action cannot be undone.
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
